import { Tooltip } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';

import { tooltipSxElevated } from '../../../../components/shared/jernyTooltipStyling';

const GROUP_KEYS = ['group0', 'group1', 'group2', 'group3', 'group4'];

export default function GroupSettingsGrouping({ form, onChange, onOpenDslEditor }) {
    return (
        <div id="group-settings-grouping">
            <div className="yns-section-label">Grouping</div>
            {GROUP_KEYS.map((key, i) => (
                <div key={key} className="j-inspector-row">
                    <span className="j-tooltip-label">G{i}</span>
                    <div className="yns-grouping-cell">
                        <input
                            className="j-inspector-select"
                            value={form[key] || ''}
                            onChange={(e) => onChange(key, e.target.value)}
                            maxLength={150}
                        />
                        {/* <Tooltip title="DSL editor" componentsProps={tooltipSxElevated}>
                            <button type="button" className="yns-dsl-btn" onClick={() => onOpenDslEditor(key)}>
                                <TuneIcon sx={{ fontSize: 15 }} />
                            </button>
                        </Tooltip> */}
                    </div>
                </div>
            ))}
            <div className="j-inspector-row">
                <span />
                <label className="yns-checkbox-cell">
                    <span className="yns-checkbox-label">Show Completed</span>
                    <input
                        type="checkbox"
                        className="yns-checkbox"
                        checked={!!form.showCompleted}
                        onChange={(e) => onChange('showCompleted', e.target.checked)}
                    />
                </label>
            </div>
        </div>
    );
}
